export const editPassword = {
  passwd: {
    props: {
      type: 'password',
    },
  },

  newpasswd: {
    props: {
      type: 'password',
    },
  },

  newpasswd2: {
    props: {
      type: 'password',
    },
  },
}
